module.exports = __webpack_public_path__ + "static/media/pfpImage.3a250252.png";